<template>
    <div class="d-flex flex-column align-items-center">
        <div class="confirmation-container">
            <div class="share-links">
                <p class="title">INVITE ARTISTS TO APPLY</p>
                <div class="icons">
                    <div v-for="icon in shareLinkIcons" :key="icon.name" class="icon">
                        <img :src="icon.src" :alt="icon.name" />
                    </div>
                </div>
            </div>
            <div class="modal-container">
                <div>
                    <img
                        @click="hideModal"
                        class="close-payment-modal"
                        :src="getIcon() + 'close-modal-btn.png'"
                    />
                </div>
                <PaymentModalContent :mode.sync="mode" v-if="mode === 'paymentModal'" />
                <SkipModalContent :mode.sync="mode" v-if="mode === 'skipPaymentInfo'" />
                <Confirmation
                    :mode="mode"
                    :isVisible.sync="isVisible"
                    v-if="mode === 'confirm'"
                />
            </div>
        </div>
    </div>
</template>
<script>
    import Confirmation from '../../parts/Confirmation.vue'
    import PaymentModalContent from './PaymentModalContent.vue'
    import SkipModalContent from './SkipModalContent.vue'

    export default {
        name: 'UpCommingEventsModal',
        components: {
            Confirmation,
            PaymentModalContent,
            SkipModalContent
        },
        props: {
            mode: {
                type: String,
                default: 'paymentModal'
            },
            isVisible: {
                type: String
            }
        },
        data: () => ({
            shareLinkIcons: [
                {
                    name: 'facebook',
                    src: '/images/icons/social/facebook_2.png'
                },
                {
                    name: 'twitter',
                    src: '/images/icons/social/twitter_2.png'
                },
                {
                    name: 'fb-message',
                    src: '/images/icons/social/fb-message.png'
                },
                {
                    name: 'whatsapp',
                    src: '/images/icons/social/whatsapp.png'
                },
                {
                    name: 'link',
                    src: '/images/icons/social/external-link.png'
                },
                {
                    name: 'message',
                    src: '/images/icons/social/message-icon.png'
                }
            ]
        }),
        methods: {
            getIcon() {
                return '/images/'
            },
            hideModal() {
                this.$emit('update:isVisible', 'hideModal')
            }
        },
        watch: {
            isVisible: function () {
                if (!this.isVisible) {
                    return this.$emit('update:isVisible', this.isVisible)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .modal-container {
        background-color: #1b0d29;
        border: 1px solid #1b0d29;
        border-radius: 15px;
        margin-top: 70px;
        position: relative;
    }
    .confirmation-container {
        overflow: auto;
        position: fixed;
        z-index: 9999;
        min-width: 903px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 100%;
    }
    .confirmation-container::-webkit-scrollbar {
        display: none;
    }
    .close-payment-modal {
        height: 32px;
        position: absolute;
        right: 20px;
        top: 15px;
        width: 35px;
        cursor: pointer;
    }
</style>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .share-links {
        order: 2;
        flex: 0 0 auto;
        margin-top: 150px;
        .title {
            font-family: 'Instrument Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 22px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: white;
            text-align: center;
        }

        .icons {
            display: flex;

            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 15px;

            .icon {
                width: 59px;
                height: 59px;
                border-radius: 50%;
                background: #d7eb5a;
                padding: 17px 17px;

                img {
                    max-width: 25px;
                    max-height: 25px;
                }
            }
        }
    }
</style>
